import { Task } from "@/api/mutation/useTaskCreateMutation";
import Clock from "../../assets/svg/Clock.svg";
import UserAvatar from "../ui/userAvatar";
import calculateTimeDifference from "../shared/TimeDifferenceCalculate";
import dateFormater from "@/helperFuntions/dateFormater";
import { useTranslation } from "react-i18next";
function TaskHistory(props: { task: Task | undefined }) {
  // const [showAll, setShowAll] = useState<boolean>(false);
  const { t } = useTranslation();
  function isValidDate(dateString: string) {
    const regex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/;
    return regex.test(dateString);
  }

  const messageCreate = (history: Task["histories"][0]): string => {
    let rawMessage = history.message || "";
    // Normalize string to snake_case i18n key or use existing key
    let translationKey = rawMessage.toLowerCase().replace(/['’]/g, "").replace(/\s+/g, "_");
    let translatedHeader = t(`history_${translationKey}`, rawMessage);
    if (translatedHeader === `history_${translationKey}`) {
      translatedHeader = t(rawMessage, rawMessage);
    }
    const toText = t("to");

    let message = translatedHeader;
    if (
      history.data.newValue !== null &&
      history.data.newValue.toString() &&
      history.data.oldValue !== null &&
      history.data.oldValue?.toString()
    ) {
      if (
        isValidDate(history.data.newValue) &&
        isValidDate(history.data.oldValue)
      ) {
        message =
          message +
          "  " +
          dateFormater(new Date(history.data.oldValue)) +
          "  " +
          ` ${toText} ` +
          dateFormater(new Date(history.data.newValue));
      } else {
        message =
          message +
          " " +
          history.data.oldValue +
          ` ${toText} ` +
          history.data.newValue;
      }
    } else {
      if (isValidDate(history.data.newValue)) {
        message = dateFormater(new Date(history.data.newValue)) + " " + message;
      } else {
        message =
          (history.data.oldValue ?? history.data.newValue) + " " + message;
      }
    }
    return message;
  };

 return (
    <div className="flex flex-col h-full min-h-0">
      {/* Header */}
      <div className="flex items-center gap-2 pb-2.5 border-b border-slate-100 shrink-0">
        <img src={Clock} width={18} height={18} className="opacity-70" alt="History" />
        <div className="text-xs font-bold text-slate-800 uppercase tracking-wider">{t("History")}</div>
      </div>

      {/* Scroll Area - Constrained to prevent parent modal scrolling */}
      <div className="flex flex-col gap-2.5 max-h-[320px] overflow-y-auto pr-1.5 mt-2.5">
        {props.task?.histories && props.task.histories.length > 0 ? (
          props.task.histories.map((history) => (
            <div
              key={history.historyId}
              className="flex gap-3 items-center p-2.5 rounded-xl bg-slate-50/60 border border-slate-100/90 hover:bg-slate-50 transition-colors"
            >
              <UserAvatar
                user={history.createdByUser}
                className="w-8 h-8 rounded-full ring-2 ring-white shadow-2xs flex-shrink-0"
              />

              <div className="flex flex-col min-w-0 flex-1">
                <div className="flex gap-2 items-center">
                  <span className="text-xs font-bold text-slate-800 truncate">
                    {history.createdByUser.firstName} {history.createdByUser.lastName || ""}
                  </span>
                  <span className="text-[11px] text-slate-400">
                    {calculateTimeDifference(new Date(history.createdAt), t)}
                  </span>
                </div>

                <p className="text-xs text-slate-600 leading-relaxed mt-0.5 break-words">
                  {messageCreate(history)}
                </p>
              </div>
            </div>
          ))
        ) : (
          <div className="text-center py-6 text-xs text-slate-400">
            {t("no_history_records_found")}
          </div>
        )}
      </div>
    </div>
  );
}

export default TaskHistory;
